__turbopack_context__.v({
  "growth-arc-orbit": "growth-stories-arc-module__ojkjIW__growth-arc-orbit",
  "mobileContent": "growth-stories-arc-module__ojkjIW__mobileContent",
  "mobileContentTight": "growth-stories-arc-module__ojkjIW__mobileContentTight",
  "orbitRing": "growth-stories-arc-module__ojkjIW__orbitRing",
});
